function loadRecaptchaApi(siteKey) {
  if (window.recaptchaApiRequested) {
    return;
  }
  window.recaptchaApiRequested = true;

  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.async = true;
  script.onerror = function reportRecaptchaError() {
    window.recaptchaApiRequested = false;
    if (window.Sentry) {
      window.Sentry.captureException(
        new Error('reCAPTCHA api.js failed to load'),
        { extra: { src: script.src } },
      );
    }
  };
  document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', function initRecaptcha() {
  const siteKey = window.RECAPTCHA_SITE_KEY;
  const action = window.RECAPTCHA_ACTION;

  if (!siteKey || !action) {
    return;
  }

  const recaptchaInput = document.getElementById(
    `g-recaptcha-response-${action}`,
  );
  if (!recaptchaInput) {
    return;
  }

  const form = recaptchaInput.closest('form');
  if (!form) {
    return;
  }

  if (form.dataset.recaptchaInitialized) {
    return;
  }
  form.dataset.recaptchaInitialized = 'true';

  // Fetch api.js while the browser is idle so a token is ready even if the user
  // focuses and submits before the focusin-triggered load.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(function prewarmRecaptcha() {
      loadRecaptchaApi(siteKey);
    });
  } else {
    setTimeout(function prewarmRecaptcha() {
      loadRecaptchaApi(siteKey);
    }, 0);
  }

  form.addEventListener(
    'focusin',
    function loadOnFirstInteraction() {
      loadRecaptchaApi(siteKey);
    },
    { once: true },
  );

  let isSubmitting = false;

  form.addEventListener('submit', function handleSubmit(e) {
    if (recaptchaInput.value) {
      return;
    }

    if (isSubmitting) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    isSubmitting = true;

    function runRecaptcha() {
      grecaptcha.ready(function execute() {
        grecaptcha
          .execute(siteKey, { action })
          .then(function onToken(token) {
            recaptchaInput.value = token;
            form.submit();
          })
          .catch(function onError(error) {
            if (window.Sentry) {
              window.Sentry.captureException(error);
            }
            form.submit();
          });
      });
    }

    if (typeof grecaptcha !== 'undefined') {
      runRecaptcha();
      return;
    }

    // The idle/focusin load may not have finished yet. Wait for it rather than
    // submitting a blank token, which the server rejects (lost quotation).
    loadRecaptchaApi(siteKey);

    let waited = 0;
    const poll = setInterval(function waitForGrecaptcha() {
      if (typeof grecaptcha !== 'undefined') {
        clearInterval(poll);
        runRecaptcha();
      } else if ((waited += 100) >= 5000) {
        clearInterval(poll);
        if (window.Sentry) {
          window.Sentry.captureMessage('reCAPTCHA not loaded');
        }
        form.submit();
      }
    }, 100);
  });
});
